import { useEffect, useState } from 'react';
import { useSolicitud } from '../../../hooks/useSolicitud';
import FormSelectBox from '../../../components/Form/FormSelectBox';
import Confirm from '../../../components/Confirm';
import { Solicitud } from '../../../classes/Solicitud';
import { useAuth } from '../../../hooks/useAuth';
import { Usuario } from '../../../types/Usuario';
import { Breadcrumbs } from '../../Home/Breadcrumb';
import { logger } from '../../../utils/logger';
import {
  CondicionNormativa,
  MarcoLegal,
} from '../../../types/Normativa';

export const CrearSolicitud = () => {
  const { getUsuarioLogueado } = useAuth();
  const [empresasGestoras, setEmpresasGestoras] = useState<any>({});
  const [tiposTrabajos, setTiposTrabajos] = useState<any>([]);
  const [idEmpresaGestora, setIdEmpresaGestora] =
    useState<string>('');
  const [idContratista, setIdContratista] = useState<string>('');
  const [contratistas, setContratistas] = useState<any>({});
  const [setTiposDocumentos] = useState<any>({});
  const [showModal, setShowModal] = useState<boolean>(false);
  const [tiposTrabajoSeleccionados, setTiposTrabajoSeleccionados] =
    useState<number[]>([]);
  const [usuarioLogin] = useState<Usuario>(getUsuarioLogueado());
  const [conAnalisisRiesgo, setConAnalisisRiesgo] =
    useState<boolean>(false);
  const [trabajosAltoRiesgo, setTrabajosAltoRiesgo] = useState<any>(
    []
  );
  const [trabajosBajoRiesgo, setTrabajosBajoRiesgo] = useState<any>(
    []
  );
  const [otrosTrabajos, setOtrosTrabajos] = useState<any>([]);

  // Estados para normativa vigente
  const [marcoLegal, setMarcoLegal] = useState<MarcoLegal[]>([]);
  const [condicionesNormativas, setCondicionesNormativas] = useState<
    CondicionNormativa[]
  >([]);
  const [condicionesAceptadas, setCondicionesAceptadas] =
    useState<boolean>(false);
  const [errorCondiciones, setErrorCondiciones] =
    useState<string>('');

  const {
    cargarCombo,
    cargarTipoTrabajo,
    handleInitSolicitud,
    cargarEmpresasGestoras,
    cargarContratistas,
    cargarTipoTrabajoAltoRiesgo,
    cargarTipoBajoRiesgo,
    cargarOtrosTrabajos,
    esConAnalisisRiesgo,
    obtenerMarcoLegalTiposTrabajo,
    obtenerCondicionesNormativaTiposTrabajo,
  } = useSolicitud();

  useEffect(() => {
    // cargarCombo('contratistas', setContratistas);
    cargarCombo('tiposDocumentos', setTiposDocumentos);
    cargarEmpresasGestoras(
      'empresasGestoras',
      `${usuarioLogin.idContratista}`,
      setEmpresasGestoras
    );
    cargarContratistas(
      'contratistas',
      `${usuarioLogin.idEmpresaGestora}`,
      setContratistas
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Verificar análisis de riesgo cuando se tiene la empresa gestora
  useEffect(() => {
    const verificarAnalisisRiesgo = async () => {
      if (usuarioLogin.idEmpresaGestora) {
        const conRiesgo = await esConAnalisisRiesgo(
          Number(usuarioLogin.idEmpresaGestora)
        );
        setConAnalisisRiesgo(conRiesgo);
      }
    };

    verificarAnalisisRiesgo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usuarioLogin.idEmpresaGestora]);
  const handleChangeGestora = async (e: any) => {
    e.preventDefault();
    const eg = e.target.value;
    setIdEmpresaGestora(eg);
    setIdContratista(`${usuarioLogin.idContratista}`);

    // Limpiar selecciones previas
    setTiposTrabajoSeleccionados([]);

    // Verificar si la empresa gestora requiere análisis de riesgo
    const conRiesgo = await esConAnalisisRiesgo(Number(eg));
    setConAnalisisRiesgo(conRiesgo);

    if (conRiesgo) {
      cargarTipoTrabajoAltoRiesgo(
        'tiposTrabajos',
        eg,
        `${usuarioLogin.idContratista}`,
        setTrabajosAltoRiesgo
      );
      cargarTipoBajoRiesgo(
        'tiposTrabajos',
        eg,
        `${usuarioLogin.idContratista}`,
        setTrabajosBajoRiesgo
      );
      cargarOtrosTrabajos(
        'tiposTrabajos',
        eg,
        `${usuarioLogin.idContratista}`,
        setOtrosTrabajos
      );
    } else {
      cargarTipoTrabajo(
        'tiposTrabajos',
        eg,
        `${usuarioLogin.idContratista}`,
        setTiposTrabajos
      );
    }
  };
  const handleChangeContratista = async (e: any) => {
    e.preventDefault();
    const contratistaID = e.target.value;
    setIdContratista(contratistaID);
    setIdEmpresaGestora(`${usuarioLogin.idEmpresaGestora}`);

    // Limpiar selecciones previas
    setTiposTrabajoSeleccionados([]);

    // Verificar si la empresa gestora requiere análisis de riesgo
    const conRiesgo = await esConAnalisisRiesgo(
      Number(usuarioLogin.idEmpresaGestora)
    );
    setConAnalisisRiesgo(conRiesgo);

    if (conRiesgo) {
      cargarTipoTrabajoAltoRiesgo(
        'tiposTrabajos',
        `${usuarioLogin.idEmpresaGestora}`,
        contratistaID,
        setTrabajosAltoRiesgo
      );
      cargarTipoBajoRiesgo(
        'tiposTrabajos',
        `${usuarioLogin.idEmpresaGestora}`,
        contratistaID,
        setTrabajosBajoRiesgo
      );
      cargarOtrosTrabajos(
        'tiposTrabajos',
        `${usuarioLogin.idEmpresaGestora}`,
        contratistaID,
        setOtrosTrabajos
      );
    } else {
      cargarTipoTrabajo(
        'tiposTrabajos',
        `${usuarioLogin.idEmpresaGestora}`,
        contratistaID,
        setTiposTrabajos
      );
    }
  };
  const toggle = () => setShowModal(!showModal);

  // Función para cargar normativa cuando se abre el modal
  const cargarNormativaVigente = async () => {
    if (conAnalisisRiesgo && tiposTrabajoSeleccionados.length > 0) {
      try {
        const [marcoLegalData, condicionesData] = await Promise.all([
          obtenerMarcoLegalTiposTrabajo(tiposTrabajoSeleccionados),
          obtenerCondicionesNormativaTiposTrabajo(
            tiposTrabajoSeleccionados
          ),
        ]);
        setMarcoLegal(marcoLegalData);
        setCondicionesNormativas(condicionesData);
        setCondicionesAceptadas(false); // Reset checkbox
        setErrorCondiciones(''); // Limpiar error
      } catch (error) {
        logger.error('Error cargando normativa:', logger.safeError(error));
      }
    }
  };

  const handleSeleccionTipoTrabajo = (tipoTrabajo: any) => {
    const tipoTrabajoId = tipoTrabajo.id;
    const index = tiposTrabajoSeleccionados.findIndex(
      (id) => id === tipoTrabajoId
    );
    if (index === -1) {
      // Agregar ID del tipo de trabajo si no está seleccionado
      setTiposTrabajoSeleccionados([
        ...tiposTrabajoSeleccionados,
        tipoTrabajoId,
      ]);
    } else {
      // Remover ID del tipo de trabajo si ya está seleccionado
      setTiposTrabajoSeleccionados(
        tiposTrabajoSeleccionados.filter((id) => id !== tipoTrabajoId)
      );
    }
  };

  const esTipoTrabajoSeleccionado = (tipoTrabajo: any): boolean => {
    return tiposTrabajoSeleccionados.some(
      (id) => id === tipoTrabajo.id
    );
  };

  const iniciarSolicitud = () => {
    if (tiposTrabajoSeleccionados.length === 0) {
      alert('Debe seleccionar al menos un tipo de trabajo');
      return;
    }

    const solicitud: Solicitud = {} as Solicitud;
    solicitud.idContratista = Number(idContratista);
    solicitud.idEmpresaGestora = Number(idEmpresaGestora);
    solicitud.idTipoTrabajo = tiposTrabajoSeleccionados[0]; // Mantener compatibilidad con el campo principal
    solicitud.tiposTrabajoSeleccionados = tiposTrabajoSeleccionados; // Enviar todos los IDs seleccionados
    handleInitSolicitud(solicitud);
  };

  const renderTiposTrabajoSection = (
    titulo: string,
    trabajos: any[]
  ) => {
    // Solo renderizar si trabajos no está vacío
    if (!trabajos || trabajos.length === 0) {
      return null;
    }

    return (
      <div className="row mt-3">
        <label className="col-form-label">{titulo}</label>
        <div className="ms-2 p-3 card p-3">
          <div className="row justify-content-start">
            {trabajos?.map((tipoTrabajo: any, index: number) => {
              const isSelected =
                esTipoTrabajoSeleccionado(tipoTrabajo);
              return (
                <div
                  key={`${titulo}-${index}`}
                  className="col-2 text-center mb-3"
                  style={{ paddingLeft: '5px', paddingRight: '5px' }}
                >
                  <a
                    href="/tipoTrabajo"
                    onClick={(e) => {
                      e.preventDefault();
                      handleSeleccionTipoTrabajo(tipoTrabajo);
                    }}
                    style={{
                      border: isSelected
                        ? '2px solid #28a745'
                        : '1px solid transparent',
                      borderRadius: '6px',
                      padding: '8px',
                      display: 'block',
                      textDecoration: 'none',
                      backgroundColor: isSelected
                        ? '#f8fff8'
                        : 'transparent',
                      transition: 'all 0.2s ease',
                      maxWidth: '120px',
                      margin: '0 auto',
                    }}
                  >
                    <img
                      src={`data:image/jpeg;base64,${tipoTrabajo.logo}`}
                      alt={tipoTrabajo.id}
                      width="70"
                      height="70"
                    />
                    <br />
                    <span
                      className="fs-9"
                      style={{
                        fontSize: '11px',
                        lineHeight: '1.2',
                        wordWrap: 'break-word',
                        display: 'block',
                        marginTop: '4px',
                      }}
                    >
                      {tipoTrabajo.descripcion}
                    </span>
                    {isSelected && (
                      <div style={{ marginTop: '5px' }}>
                        <i
                          className="fa fa-check-circle"
                          style={{
                            color: '#28a745',
                            fontSize: '16px',
                          }}
                        ></i>
                      </div>
                    )}
                  </a>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  };

  // Función para obtener el indicador de riesgo de un tipo de trabajo
  const obtenerIndicadorRiesgo = (idTipoTrabajo: number) => {
    if (trabajosAltoRiesgo.some((t: any) => t.id === idTipoTrabajo)) {
      return { color: '#FF0000', texto: 'RIESGO MODERADO / ALTO' }; // Rojo
    }
    if (trabajosBajoRiesgo.some((t: any) => t.id === idTipoTrabajo)) {
      return { color: '#FFD700', texto: 'RIESGO BAJO' }; // Amarillo
    }
    return { color: '#008000', texto: 'OTROS TRABAJOS' }; // Verde
  };

  // Función para validar e iniciar solicitud
  const validarEIniciarSolicitud = () => {
    if (
      conAnalisisRiesgo &&
      condicionesNormativas.length > 0 &&
      !condicionesAceptadas
    ) {
      setErrorCondiciones(
        'Debe aceptar las condiciones de la normativa vigente para continuar'
      );
      return;
    }
    setErrorCondiciones(''); // Limpiar error si todo está bien
    iniciarSolicitud();
  };

  return (
    <>
      <div className="content-page">
        <div className="content">
          <div className="container-fluid">
            <Breadcrumbs
              title={'Alta de Solicitud'}
              nameFirst={'Consulta de Solicitudes'}
              urlFirst={'/consultaSolicitudes'}
            />
            <div className="form-horizontal">
              <div className="row">
                <Confirm
                  isOpen={showModal}
                  toggle={toggle}
                  title="Confirmar Solicitud"
                  yesFn={validarEIniciarSolicitud}
                  size="lg"
                >
                  <div className="form-horizontal">
                    <div className="row">
                      <p>
                        Está iniciando una solicitud para los
                        siguientes Tipos de Trabajo:
                      </p>

                      {/* Lista de tipos de trabajo con indicadores de riesgo */}
                      {tiposTrabajoSeleccionados.length > 0 && (
                        <div style={{ marginBottom: '20px' }}>
                          {tiposTrabajoSeleccionados.map(
                            (id, index) => {
                              const todosLosTipos = [
                                ...tiposTrabajos,
                                ...trabajosAltoRiesgo,
                                ...trabajosBajoRiesgo,
                                ...otrosTrabajos,
                              ];
                              const tipo = todosLosTipos.find(
                                (t) => t.id === id
                              );
                              const indicador = conAnalisisRiesgo
                                ? obtenerIndicadorRiesgo(id)
                                : null;

                              return (
                                <div
                                  key={index}
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    marginBottom: '10px',
                                    padding: '8px',
                                    border: '1px solid #ddd',
                                    borderRadius: '4px',
                                  }}
                                >
                                  {/* Semáforo indicativo - Solo si conAnalisisRiesgo */}
                                  {conAnalisisRiesgo && indicador && (
                                    <div
                                      style={{
                                        width: '20px',
                                        height: '20px',
                                        backgroundColor:
                                          indicador.color,
                                        borderRadius: '50%',
                                        marginRight: '10px',
                                        border: '2px solid #333',
                                      }}
                                    ></div>
                                  )}
                                  <div>
                                    <strong>
                                      {tipo?.descripcion ||
                                        `ID: ${id}`}
                                    </strong>
                                    {/* Texto de riesgo - Solo si conAnalisisRiesgo */}
                                    {conAnalisisRiesgo &&
                                      indicador && (
                                        <>
                                          <br />
                                          <small
                                            style={{
                                              color: indicador.color,
                                              fontWeight: 'bold',
                                            }}
                                          >
                                            {indicador.texto}
                                          </small>
                                        </>
                                      )}
                                  </div>
                                </div>
                              );
                            }
                          )}
                        </div>
                      )}

                      {/* Normativa Vigente - Solo si es con análisis de riesgo */}
                      {conAnalisisRiesgo &&
                        (marcoLegal.length > 0 ||
                          condicionesNormativas.length > 0) && (
                          <div
                            style={{
                              border: '2px solid #000',
                              borderRadius: '8px',
                              padding: '15px',
                              marginTop: '20px',
                            }}
                          >
                            <h5
                              style={{
                                textAlign: 'center',
                                marginBottom: '15px',
                              }}
                            >
                              <strong>Normativa Vigente</strong>
                            </h5>

                            {/* Marco Legal */}
                            {marcoLegal.length > 0 && (
                              <div style={{ marginBottom: '15px' }}>
                                <h6>
                                  <strong>Marco Legal:</strong>
                                </h6>
                                {marcoLegal.map((marco, index) => (
                                  <div
                                    key={index}
                                    style={{
                                      marginBottom: '8px',
                                      padding: '5px 0',
                                      borderLeft: '3px solid #007bff',
                                      paddingLeft: '10px',
                                      backgroundColor: '#f8f9fa',
                                    }}
                                  >
                                    {marco}
                                  </div>
                                ))}
                              </div>
                            )}

                            {/* Barreras Físicas y Administrativas */}
                            {condicionesNormativas.length > 0 && (
                              <div>
                                <h6>
                                  <strong>Barreras Físicas</strong>
                                </h6>
                                <ul style={{ marginBottom: '15px' }}>
                                  {condicionesNormativas
                                    .filter(
                                      (condicion) =>
                                        condicion.tipo === 'Física'
                                    )
                                    .map((condicion, index) => (
                                      <li key={index}>
                                        {condicion.condicion}
                                      </li>
                                    ))}
                                </ul>

                                <h6>
                                  <strong>
                                    Barreras Administrativas
                                  </strong>
                                </h6>
                                <ul style={{ marginBottom: '15px' }}>
                                  {condicionesNormativas
                                    .filter(
                                      (condicion) =>
                                        condicion.tipo ===
                                        'Administrativa'
                                    )
                                    .map((condicion, index) => (
                                      <li key={index}>
                                        {condicion.condicion}
                                      </li>
                                    ))}
                                </ul>
                              </div>
                            )}

                            {/* Checkbox de aceptación */}
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                marginTop: '20px',
                                padding: '10px',
                                backgroundColor: '#f8f9fa',
                                borderRadius: '4px',
                              }}
                            >
                              <input
                                type="checkbox"
                                id="aceptarCondiciones"
                                checked={condicionesAceptadas}
                                onChange={(e) => {
                                  setCondicionesAceptadas(
                                    e.target.checked
                                  );
                                  // Limpiar error cuando el usuario cambie el checkbox
                                  if (e.target.checked) {
                                    setErrorCondiciones('');
                                  }
                                }}
                                style={{
                                  marginRight: '10px',
                                  transform: 'scale(1.2)',
                                }}
                              />
                              <label
                                htmlFor="aceptarCondiciones"
                                style={{ fontWeight: 'bold' }}
                              >
                                He Leído y Acepto las condiciones
                              </label>
                            </div>

                            {/* Mensaje de error */}
                            {errorCondiciones && (
                              <div
                                style={{
                                  color: '#dc3545',
                                  backgroundColor: '#f8d7da',
                                  border: '1px solid #f5c6cb',
                                  borderRadius: '4px',
                                  padding: '10px',
                                  marginTop: '10px',
                                  fontSize: '14px',
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                              >
                                <i
                                  className="fa fa-exclamation-triangle"
                                  style={{
                                    marginRight: '8px',
                                    fontSize: '16px',
                                  }}
                                ></i>
                                {errorCondiciones}
                              </div>
                            )}
                          </div>
                        )}

                      <div
                        style={{
                          marginTop: '20px',
                          textAlign: 'center',
                        }}
                      >
                        <p>
                          <strong>
                            Desea confirmar el Inicio de Solicitud?
                          </strong>
                        </p>
                      </div>
                    </div>
                  </div>
                </Confirm>
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="d-flex justify-content-center">
                        {usuarioLogin.tipoUsuarioValor ===
                        'CONTRATISTA' ? (
                          <FormSelectBox
                            title={'Empresa Gestora'}
                            label={'empresa gestora'}
                            id={'empresaGestora'}
                            name={'idEmpresaGestora'}
                            onChange={handleChangeGestora}
                            optionId={'id'}
                            optionLabel={'nombreEmpresa'}
                            value={idEmpresaGestora}
                            options={empresasGestoras}
                            classLabel="col-form-label col-2 text-left"
                            classDivSelect="col-8"
                            styleLabelColor="black"
                          />
                        ) : (
                          <FormSelectBox
                            title={'Contratista'}
                            label={'contratista'}
                            id={'contratista'}
                            name={'idContratista'}
                            onChange={handleChangeContratista}
                            optionId={'id'}
                            optionLabel={'razonSocial'}
                            value={idContratista}
                            options={contratistas}
                            classLabel="col-form-label col-2 text-left"
                            classDivSelect="col-8"
                            styleLabelColor="black"
                          />
                        )}
                      </div>
                      <div className="row mt-3">
                        <label className="col-form-label">
                          Tipos de Trabajo
                        </label>

                        {!conAnalisisRiesgo ? (
                          // Vista normal - una sola sección
                          <div className="ms-2 p-3 card p-3">
                            <div className="row justify-content-start">
                              {tiposTrabajos?.map(
                                (tipoTrabajo: any, index: number) => {
                                  const isSelected =
                                    esTipoTrabajoSeleccionado(
                                      tipoTrabajo
                                    );
                                  return (
                                    <div
                                      key={index}
                                      className="col-2 text-center mb-3"
                                      style={{
                                        paddingLeft: '5px',
                                        paddingRight: '5px',
                                      }}
                                    >
                                      <a
                                        href="/tipoTrabajo"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          handleSeleccionTipoTrabajo(
                                            tipoTrabajo
                                          );
                                        }}
                                        style={{
                                          border: isSelected
                                            ? '2px solid #28a745'
                                            : '1px solid transparent',
                                          borderRadius: '6px',
                                          padding: '8px',
                                          display: 'block',
                                          textDecoration: 'none',
                                          backgroundColor: isSelected
                                            ? '#f8fff8'
                                            : 'transparent',
                                          transition: 'all 0.2s ease',
                                          maxWidth: '120px',
                                          margin: '0 auto',
                                        }}
                                      >
                                        <img
                                          src={`data:image/jpeg;base64,${tipoTrabajo.logo}`}
                                          alt={tipoTrabajo.id}
                                          width="70"
                                          height="70"
                                        />
                                        <br />
                                        <span
                                          className="fs-9"
                                          style={{
                                            fontSize: '11px',
                                            lineHeight: '1.2',
                                            wordWrap: 'break-word',
                                            display: 'block',
                                            marginTop: '4px',
                                          }}
                                        >
                                          {tipoTrabajo.descripcion}
                                        </span>
                                        {isSelected && (
                                          <div
                                            style={{
                                              marginTop: '5px',
                                            }}
                                          >
                                            <i
                                              className="fa fa-check-circle"
                                              style={{
                                                color: '#28a745',
                                                fontSize: '16px',
                                              }}
                                            ></i>
                                          </div>
                                        )}
                                      </a>
                                    </div>
                                  );
                                }
                              )}
                            </div>
                          </div>
                        ) : (
                          // Vista con análisis de riesgo - tres secciones
                          <>
                            {renderTiposTrabajoSection(
                              'Trabajos de Riesgo Moderado/Alto',
                              trabajosAltoRiesgo
                            )}
                            {renderTiposTrabajoSection(
                              'Trabajos de Riesgo Bajo',
                              trabajosBajoRiesgo
                            )}
                            {renderTiposTrabajoSection(
                              'Otros Trabajos',
                              otrosTrabajos
                            )}
                          </>
                        )}
                      </div>

                      {/* Botón para confirmar selección */}
                      {tiposTrabajoSeleccionados.length > 0 && (
                        <div className="row mt-4">
                          <div className="col-12 text-center">
                            <button
                              type="button"
                              className="btn btn-success btn-lg"
                              onClick={async () => {
                                await cargarNormativaVigente();
                                setShowModal(true);
                              }}
                            >
                              Crear Solicitud
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
